/**
 * EG Search (Meilisearch) – autocomplete API.
 *
 * Small `fetch()` wrappers used by the header autocomplete dropdown.
 */
window.EGSearchAutocompleteApi = (function() {
  'use strict';

  const config = window.EGSearchConfig;
  // Keep pack SKUs out of autocomplete results.
  const EXCLUDE_FILTER = "product_type != 'Raised Garden Beds - Pack'";

  /**
   * Fetch suggestions + products + articles in parallel.
   * @param {string} query - Search query
   * @returns {Promise<{suggestionsData: Object, productsData: Object, articlesData: Object}>}
   */
  async function fetchResults(query) {
    const [suggestionsRes, productsRes, articlesRes] = await Promise.all([
      fetch(`${config.API_BASE}/autocomplete?q=${encodeURIComponent(query)}&limit=20`),
      fetch(`${config.API_BASE}/search?q=${encodeURIComponent(query)}&hitsPerPage=20&filters=${encodeURIComponent(EXCLUDE_FILTER)}`),
      fetch(`${config.API_BASE}/articles/search?q=${encodeURIComponent(query)}&limit=3`)
    ]);

    if (!suggestionsRes.ok || !productsRes.ok) {
      throw new Error('API error');
    }

    const suggestionsData = await suggestionsRes.json();
    const productsData = await productsRes.json();
    const articlesData = articlesRes.ok ? await articlesRes.json() : { hits: [], nbHits: 0 };

    return { suggestionsData, productsData, articlesData };
  }

  /** Fetch suggestions only. */
  async function fetchSuggestions(query) {
    const res = await fetch(`${config.API_BASE}/autocomplete?q=${encodeURIComponent(query)}&limit=20`);
    if (!res.ok) throw new Error('API error');
    return res.json();
  }

  /** Fetch products only. */
  async function fetchProducts(query, limit = 20) {
    const res = await fetch(`${config.API_BASE}/search?q=${encodeURIComponent(query)}&hitsPerPage=${limit}&filters=${encodeURIComponent(EXCLUDE_FILTER)}`);
    if (!res.ok) throw new Error('API error');
    return res.json();
  }

  /** Fetch articles only. */
  async function fetchArticles(query, limit = 3) {
    const res = await fetch(`${config.API_BASE}/articles/search?q=${encodeURIComponent(query)}&limit=${limit}`);
    if (!res.ok) return { hits: [], nbHits: 0 };
    return res.json();
  }

  return {
    fetchResults,
    fetchSuggestions,
    fetchProducts,
    fetchArticles
  };
})();
